import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { selectCurrentApplication } from "@redux";
import PdfDocView from "@components/PdfDocument/PdfDocView";
import { APP_STATES, DOCUMENT_TYPES } from "@config";
import { PPPApproveKyc, PPPRequestDocs } from "../../Elements";

export const PPPTab = React.memo(() => {
  const app = useSelector(selectCurrentApplication);

  const lastTypeApplicationDocumentId = useMemo(() => {
    const appTypeDocs = (app?.documents || []).filter(({ type }) => type === DOCUMENT_TYPES.APP);
    return appTypeDocs.length > 0 ? appTypeDocs.at(-1).id : null;
  }, [app?.documents]);

  return (
    <>
      {app?.state === APP_STATES.WAITING_FOR_OFFICER_REVIEW && <PdfDocView documentId={lastTypeApplicationDocumentId} showButtons={false} />}
      {app?.state === APP_STATES.WAITING_FOR_OFFICER_REVIEW && <PPPApproveKyc appId={app?.id} />}
      {app?.state === APP_STATES.WAITING_FOR_OFFICER_DOC_REVIEW && (
        <PPPRequestDocs appId={app?.id} />
      )}
    </>
  );
});
